import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  template: `
    <div class="flex justify-between gap-4">
      <div class="flex-1">
        <h2 class="orgbrain-mat-dialog-header !mt-0 p-0 mb-2">
          {{ title }}
        </h2>

        <p class="mat-body" *ngIf="!isMessageAnArray(); else messageArrayTemplate">
          <span [innerHTML]="message"></span>
        </p>
      </div>
      <mat-icon class="text-orgbrain-complete fill-icon !text-[48px] !w-12 !h-12"
        >check_circle</mat-icon
      >
    </div>

    <div class="flex justify-end gap-2 items-center mt-8">
      <button mat-flat-button color="primary" (click)="dialogRef.close(true)" cdkFocusInitial>
        {{ okOptionTitle }}
      </button>
    </div>
    <ng-template #messageArrayTemplate>
      <p class="mat-body" *ngFor="let msg of message" [innerHTML]="msg"></p>
    </ng-template>
  `,
  styleUrls: ['../dialog.component.scss'],
  standalone: false,
})
export class CompletionDialogComponent {
  okOptionTitle: string;
  title: string;
  message: string | string[];
  public dialogRef = inject(MatDialogRef<CompletionDialogComponent>);

  isMessageAnArray() {
    return Array.isArray(this.message);
  }
}
